import { render, staticRenderFns } from "./Toric.vue?vue&type=template&id=984c6068"
import script from "./Toric.vue?vue&type=script&lang=js"
export * from "./Toric.vue?vue&type=script&lang=js"
import style0 from "./Toric.vue?vue&type=style&index=0&id=984c6068&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports